import {FormConfig} from "../../form/form.config";
import {FormModel} from "../../form/form.model.abstract";
import {FormModelRadio} from "../../form/form.model.radio";
import {UntypedFormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FormModelNumber} from "../../form/form.model.number";
import {FormModelText} from "../../form/form.model.text";
import {ValidationService} from "../../services/validation.service";
import {FormModelHidden} from "../../form/form.model.hidden";
import {ModeratConstants} from "../moderat.constants";
import {FormModelPercent} from "../../form/form.model.percent";
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";

/**
 * Configuratuion for the input of the first chapter in the moderat advisor.
 * @inheritDoc
 */
export class BestandsaufnahmeForm extends FormConfig {

  /**
   * some data is needed here for validation
   */
  public anfrage: ModeratAnfrage;

  /**
   * @inheritDoc
   * @protected
   */
  protected fields: FormModel[] = [
    // gebaeudedetails
    (new FormModelRadio('gebaeude_lage', ['freistehend', 'mitte', 'ecke', 'dhh'], [Validators.required], null, null, true)).setIconPath('/moc/icon-gebaeude_lage_'),
    (new FormModelRadio('gebaeude_grundriss', ['kompakt', 'komplex'], [Validators.required], null, null, false)).setIconPath('/moc/icon-gebaeude_grundriss_'),
    new FormModelNumber('gebaeude_stockwerke', [Validators.required, Validators.min(ModeratConstants.FORM_FLOOR_MIN_MFH), Validators.max(ModeratConstants.FORM_FLOOR_MAX_MFH), ValidationService.allowIntegerOnly],  null, ModeratConstants.FORM_FLOOR_MIN_MFH, false),
    (new FormModelRadio('gebaeude_dachform', ['spitzdach', 'flachdach', 'pultdach'], [Validators.required], null, null, false)).setIconPath('/moc/icon-gebaeude_dachform_'),
    new FormModelRadio('gebaeude_dachausbau', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('gebaeude_flaechenanteil_fenster', ['niedrig', 'mittel', 'hoch'], [Validators.required], null, null, false)).setIconPath('/moc/icon-gebaeude_flaechenanteil_fenster_'),

    // gebaeudedetails/fenster
    (new FormModelRadio('fenster_verglasungsart', ['einfach', 'zweifachverbund', 'zweifachwaermeschutz', 'dreifachwaermeschutz'], [Validators.required], null, null, true)).setIconPath('/moc/icon-fenster_verglasungsart_'),
    new FormModelRadio('fenster_zustand', ['unbekannt', 'nicht_erneuert', 'erneuert'], [Validators.required], null, null, false),
    (new FormModelText('fenster_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('windowyear').setInactive(),
    new FormModelRadio('fenster_flaechenanteil_alle', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelPercent('flaechenanteil', ['fenster_flaechenanteil', 'fenster_flaechenanteil_2'], [Validators.required], [100, 0], false)).setInactive(),
    (new FormModelRadio('fenster_verglasungsart_2', ['einfach', 'zweifachverbund', 'zweifachwaermeschutz', 'dreifachwaermeschutz'], [Validators.required], null, null, true)).setIconPath('/moc/icon-fenster_verglasungsart_').setInactive(),
    (new FormModelRadio('fenster_zustand_2', ['unbekannt', 'nicht_erneuert', 'erneuert'], [Validators.required], null, null, false)).setInactive(),
    (new FormModelText('fenster_baujahr_2', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('windowyear').setInactive(),


    // heizanlage
    new FormModelHidden('heizsystem_typ', 'niedertemperaturkessel'),
    new FormModelRadio('kessel_brennwerttechnik', ['ja', 'nein', 'unbekannt'], [Validators.required], null, null, false),
    new FormModelRadio('heizsystem_zustand', ['unbekannt', 'nicht_erneuert', 'erneuert'], [Validators.required], null, null, false),
    (new FormModelText('heizsystem_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive(),
    new FormModelRadio('solarthermie_zustand', ['unbekannt', 'nicht_erneuert', 'erneuert'], [Validators.required], null, null, false),
    (new FormModelText('solarthermie_baujahr', [Validators.required, ValidationService.minBuildingYear(ModeratConstants.FORM_SOLAR_THERMAL_BUILDING_YEAR_MIN)], null, null, false, 'number')).setErrorId('solar_thermal_year').setClasses('small-field').setInactive(),
    new FormModelRadio('hydraulikabgleich_zustand', ['unbekannt', 'nicht_durchgefuehrt', 'durchgefuehrt'], [Validators.required], null, null, false),
    (new FormModelText('hydraulikabgleich_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive(),
    new FormModelRadio('photovoltaik_vorhanden', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelText('photovoltaik_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive(),
    new FormModelRadio('lueftungsanlage_vorhanden', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelText('lueftungsanlage_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive(),
    new FormModelRadio('fussbodenheizung_vorhanden', ['ja', 'nein'], [Validators.required], null, null, false),

    // daemmung
    new FormModelRadio('dach_zustand', ['unbekannt', 'nicht_gedaemmt', 'gedaemmt'], [Validators.required], null, null, false),
    (new FormModelText('dach_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setClasses('small-field').setInactive(),
    new FormModelRadio('obergeschoss_zustand', ['unbekannt', 'nicht_gedaemmt', 'gedaemmt'], [Validators.required], null, null, false),
    (new FormModelText('obergeschoss_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive(),
    new FormModelRadio('fassade_zustand', ['unbekannt', 'nicht_gedaemmt', 'gedaemmt'], [Validators.required], null, null, false),
    (new FormModelText('fassade_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive(),
    new FormModelRadio('kellerdecke_zustand', ['unbekannt', 'nicht_gedaemmt', 'gedaemmt'], [Validators.required], null, null, false),
    (new FormModelText('kellerdecke_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setErrorId('buildingyear').setClasses('small-field').setInactive()
  ];

  /**
   * @inheritDoc
   * @protected
   */
  protected formValidators = [
    BestandsaufnahmeForm.windowBuildingYear(this),
  ];

  /**
   * List of formfields where changes of the value, change other fields and that are on the same step
   */
  fieldsForFormChanges: string[] = ['heizsystem_zustand', 'fenster_zustand', 'fenster_zustand_2', 'fenster_flaechenanteil_alle', 'dach_zustand', 'obergeschoss_zustand', 'fassade_zustand',
    'kellerdecke_zustand', 'hydraulikabgleich_zustand', 'photovoltaik_vorhanden', 'lueftungsanlage_vorhanden', 'fenster_verglasungsart', 'fenster_verglasungsart_2', 'solarthermie_zustand'];

  /**
   * The options for some fields that are dynamic, depending on other form fields
   */
  static readonly options: any = {
    'gebaeude_lage': {
      'mehrfamilienhaus': ['freistehend', 'mitte', 'ecke'],
      'einfamilienhaus': ['freistehend', 'mitte', 'ecke', 'dhh'],
      'zweifamilienhaus': ['freistehend', 'mitte', 'ecke', 'dhh'],
      '1-2familienhaus': ['freistehend', 'mitte', 'ecke', 'dhh']
    }
  }

  /**
   * konfiguration for the validation of window types
   */
  static readonly fensterVerglasungsartValidators: {[key: string]: {min: number, max: number}} = {
    'einfach': {min: 0, max: 1978},
    'zweifachverbund': {min: 0, max: 1994},
    'zweifachwaermeschutz': {min: 1995, max: 0},
    'dreifachwaermeschutz': {min: 2002, max: 0}
  }

  /**
   * validates the building year of a window based on its type.
   * @param formConfig
   */
  static windowBuildingYear(formConfig: BestandsaufnahmeForm): ValidatorFn {
    return (formGroup: UntypedFormGroup) => {
      const validations = BestandsaufnahmeForm.fensterVerglasungsartValidators
      const typeField = 'fenster_verglasungsart';
      const yearField = 'fenster_baujahr';
      const statusField = 'fenster_zustand';

      // validate both field sets, first and second
      for(const postfix of ['', '_2']) {
        // if the window type and a renewal year is given, check the date agains min and max of the type
        if (formGroup.controls[typeField + postfix]?.value && formGroup.controls[statusField + postfix]?.value === 'erneuert' && formGroup.controls[yearField + postfix]?.value) {
          const year = parseInt(formGroup.controls[yearField + postfix].value);
          const type = formGroup.controls[typeField + postfix].value;

          if (year < validations[type].min || (validations[type].max > 0 && year > validations[type].max)) {
            return {windowBuildingYear: false}
          }
        }

        // if the window type is not replaces, check the building year agains the min year of the type
        const buildingYear = formConfig?.anfrage?.verbrauchsanalyseInput?.gebaeudebaujahr;
        if (buildingYear && formGroup.controls[statusField + postfix]?.value && formGroup.controls[typeField + postfix]?.value) {
          const type = formGroup.controls[typeField + postfix].value;
          const min = validations[type].min;
          if (formGroup.controls[statusField + postfix]?.value === "nicht_erneuert" && buildingYear < min) {
            return {windowBuildingYear: false}
          }
        }
      }

      // everything is fine, of the fields are not theire, of they have no values
      return null;
    }
  }

  /**
   * returns the list of possible options for field fenster_verglasungsart based on the building year.
   * @param gebaeudebaujahr
   */
  static getVerglasungsoptionsForBaujahr(gebaeudebaujahr): string[] {
    return Object.keys(BestandsaufnahmeForm.fensterVerglasungsartValidators).filter(type => {
      return BestandsaufnahmeForm.fensterVerglasungsartValidators[type].max === 0 ||
        gebaeudebaujahr <= BestandsaufnahmeForm.fensterVerglasungsartValidators[type].max;
    });
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected groups = {
    'gebaeudedetails/1': ['gebaeude_lage'],
    'gebaeudedetails/2': ['gebaeude_grundriss'],
    'gebaeudedetails/3': ['gebaeude_stockwerke'],
    'gebaeudedetails/4': ['gebaeude_dachform'],
    'gebaeudedetails/5': ['gebaeude_dachausbau'],
    'gebaeudedetails/6': ['gebaeude_flaechenanteil_fenster'],
    'gebaeudedetails/7': ['fenster_verglasungsart', 'fenster_zustand', 'fenster_baujahr', 'fenster_flaechenanteil_alle', 'flaechenanteil', 'fenster_verglasungsart_2',
      'fenster_zustand_2', 'fenster_baujahr_2'],

    'heizanlage/1': ['kessel_brennwerttechnik'],
    'heizanlage/2': ['heizsystem_zustand', 'heizsystem_baujahr', 'heizsystem_typ'],
    'heizanlage/3': ['solarthermie_zustand', 'solarthermie_baujahr'],
    'heizanlage/4': ['hydraulikabgleich_zustand', 'hydraulikabgleich_baujahr'],
    'heizanlage/5': ['photovoltaik_vorhanden', 'photovoltaik_baujahr'],
    'heizanlage/6': ['lueftungsanlage_vorhanden', 'lueftungsanlage_baujahr'],
    'heizanlage/7': ['fussbodenheizung_vorhanden'],

    'daemmung/1': ['kellerdecke_zustand', 'kellerdecke_baujahr'],
    'daemmung/2': ['fassade_zustand', 'fassade_baujahr'],
    'daemmung/3': ['dach_zustand', 'dach_baujahr', 'obergeschoss_zustand', 'obergeschoss_baujahr'],

    // wpcheck
    'wpcheizanlage/1': ['kessel_brennwerttechnik'],
    'wpcheizanlage/2': ['heizsystem_zustand', 'heizsystem_baujahr', 'heizsystem_typ'],
    'wpcheizanlage/3': ['solarthermie_zustand', 'solarthermie_baujahr'],
    'wpcheizanlage/4': ['photovoltaik_vorhanden', 'photovoltaik_baujahr'],
    'wpcheizanlage/5': ['lueftungsanlage_vorhanden', 'lueftungsanlage_baujahr']
  };

  /**
   * Date of fields are changed (preset or by user). de/activate fields, preset defaults and change validation
   * @param values
   */
  updateFields(values: {[key: string]: any}): void {

    // based on the field energietraeger_name, the question for heizsystem_typ can be presetted in some cases
    if(values.hasOwnProperty('energietraeger_name')) {
      switch(values.energietraeger_name) {
        case 'holzpellets':
          this.getField('heizsystem_typ').setValue('holzpelletsheizkessel')
          this.deactivateField('kessel_brennwerttechnik');
          break;
        case 'fernwaerme':
          this.getField('heizsystem_typ').setValue('fernwaerme_uebergabestation')
          this.deactivateField('kessel_brennwerttechnik');
          break;
        case 'strom':
        case 'waermepumpe':
        case 'waermepumpe_luft':
        case 'waermepumpe_wasser':
          this.getField('heizsystem_typ').setValue(values.energietraeger_name);
          this.deactivateField('kessel_brennwerttechnik');
          break;
        case 'erdgas':
        case 'heizoel':
        case 'fluessiggas':
          this.activateField('kessel_brennwerttechnik');
          break;
        default:
          this.getField('heizsystem_typ').setValue('niedertemperaturkessel')
          this.deactivateField('kessel_brennwerttechnik');
      }
    }

    // based on gebaeudetyp, set some validators for the floor number
    if(values.hasOwnProperty('gebaeudetyp')) {
      this.setOptions('gebaeude_lage', BestandsaufnahmeForm.options.gebaeude_lage[values.gebaeudetyp]);

      if(values.gebaeudetyp === 'mehrfamilienhaus') {
        this.setFieldValidators('gebaeude_stockwerke', [Validators.required, Validators.min(ModeratConstants.FORM_FLOOR_MIN_MFH), Validators.max(ModeratConstants.FORM_FLOOR_MAX_MFH), ValidationService.allowIntegerOnly]);
      }
      else {
        this.setFieldValidators('gebaeude_stockwerke', [Validators.required, Validators.min(ModeratConstants.FORM_FLOOR_MIN_EFH), Validators.max(ModeratConstants.FORM_FLOOR_MAX_EFH), ValidationService.allowIntegerOnly]);
      }
    }

    // based on keller_status, show/hide keller_status
    if(values.hasOwnProperty('keller_status')) {
      if(values.keller_status === 'vorhanden') {
        this.activateField('kellerdecke_zustand');
      }
      else {
        this.deactivateField('kellerdecke_zustand');
        this.deactivateField('kellerdecke_baujahr');
      }
    }

    // based on solarthermie_art, show/hide solarthermie_zustand
    if(values.hasOwnProperty('solarthermie_art')) {
      if(values.solarthermie_art === 'warmwasser' || values.solarthermie_art === 'warmwasser_heizung') {
        this.activateField('solarthermie_zustand');
      }
      else {
        this.deactivateField('solarthermie_zustand');
        values.solarthermie_zustand = null;
        this.deactivateField('solarthermie_baujahr');
        values.solarthermie_baujahr = null;
      }
    }

    // add validators on some year fields to the minimum of the building year
    if(values.hasOwnProperty('gebaeudebaujahr')) {
      // set options of fenster_verglasungsart
      const options = BestandsaufnahmeForm.getVerglasungsoptionsForBaujahr(values.gebaeudebaujahr);

      this.setOptions('fenster_verglasungsart', options);
      this.setOptions('fenster_verglasungsart_2', options);

      ['fenster_baujahr', 'fenster_baujahr_2', 'heizsystem_baujahr', 'hydraulikabgleich_baujahr', 'photovoltaik_baujahr', 'lueftungsanlage_baujahr', 'dach_baujahr', 'obergeschoss_baujahr', 'fassade_baujahr', 'kellerdecke_baujahr'].forEach(fieldName => {
        this.setFieldValidators(fieldName, [Validators.required, ValidationService.buildingYear, Validators.min(values.gebaeudebaujahr * 1)]);
      });
      this.setFieldValidators('solarthermie_baujahr', [Validators.required, ValidationService.minBuildingYear(ModeratConstants.FORM_SOLAR_THERMAL_BUILDING_YEAR_MIN),
        Validators.min(values.gebaeudebaujahr * 1)]);
    }

    // kessel_brennwerttechnik
    if(values.hasOwnProperty('kessel_brennwerttechnik') && this.getField('kessel_brennwerttechnik').isActive()) {
      if(values.kessel_brennwerttechnik === 'ja') {
        this.getField('heizsystem_typ').setValue('brennwertkessel');
        values.heizsystem_typ = 'brennwertkessel';
      }
      else {
        this.getField('heizsystem_typ').setValue('niedertemperaturkessel');
        values.heizsystem_typ = 'niedertemperaturkessel';
      }
    }

    // gebaeude_dachform -> gebaeude_dachausbau
    if(values.hasOwnProperty('gebaeude_dachform')) {
      if(values.gebaeude_dachform === 'spitzdach') {
        this.activateField('gebaeude_dachausbau');
      }
      else {
        this.deactivateField('gebaeude_dachausbau');
        values.gebaeude_dachausbau = null;
      }
    }
    // based on gebaeude_dachform show/hide dach_* and obergeschoss_*
    if(values.hasOwnProperty('gebaeude_dachform') && values.hasOwnProperty('gebaeude_dachausbau')) {
      if(values.gebaeude_dachform === 'spitzdach' && values.gebaeude_dachausbau === 'nein') {
        this.deactivateField('dach_zustand');
        this.activateField('obergeschoss_zustand');
        values.dach_zustand = null;
      }
      else {
        this.activateField('dach_zustand');
        this.deactivateField('obergeschoss_zustand');
        values.obergeschoss_zustand = null;
      }
    }

    // *_zustand -> de/activate *_baujahr
    ['heizsystem_', 'hydraulikabgleich_', 'fenster_', 'dach_', 'obergeschoss_', 'fassade_', 'kellerdecke_', 'solarthermie_'].forEach(fieldPrefix => {
      if(values.hasOwnProperty(fieldPrefix + 'zustand')) {
        if(values[fieldPrefix + 'zustand'] === 'erneuert' || values[fieldPrefix + 'zustand'] === 'durchgefuehrt' || values[fieldPrefix + 'zustand'] === 'gedaemmt') {
          this.activateField(fieldPrefix + 'baujahr');
        }
        else {
          this.deactivateField(fieldPrefix + 'baujahr');
          values[fieldPrefix + 'baujahr'] = null;
          this.form.controls[fieldPrefix + 'baujahr']?.setValue(null, {onlySelf: true});
        }
      }
    });

    // activate field *_baujahr if *_vorhanden === ja
    ['photovoltaik_', 'lueftungsanlage_'].forEach(fieldPrefix => {
      if(values.hasOwnProperty(fieldPrefix + 'vorhanden')) {
        if(values[fieldPrefix + 'vorhanden'] === 'ja') {
          this.activateField( fieldPrefix + 'baujahr');
        }
        else {
          this.deactivateField(fieldPrefix + 'baujahr');
          values[fieldPrefix + 'baujahr'] = null;
          this.form.controls[fieldPrefix + 'baujahr']?.setValue(null, {onlySelf: true});
        }
      }
    });

    // second window types
    if(values.hasOwnProperty('fenster_flaechenanteil_alle')) {
      if(values.fenster_flaechenanteil_alle === 'nein') {
        ['flaechenanteil', 'fenster_verglasungsart_2', 'fenster_zustand_2', 'fenster_flaechenanteil_2'].forEach(fieldName => this.activateField(fieldName));
      }
      if(values.fenster_flaechenanteil_alle === 'ja') {
        values.fenster_flaechenanteil = 100;
        values.fenster_flaechenanteil_2 = 0;
        ['flaechenanteil', 'fenster_verglasungsart_2', 'fenster_zustand_2', 'fenster_flaechenanteil_2'].forEach(fieldName => {
          this.deactivateField(fieldName);
          values[fieldName] = null;
        });
      }
    }

    if(values.hasOwnProperty('fenster_zustand_2')) {
      if(values['fenster_zustand_2'] === 'erneuert') {
        this.activateField('fenster_baujahr_2');
      }
      else {
        this.deactivateField('fenster_baujahr_2');
        values['fenster_baujahr_2'] = null;
        this.form.controls['fenster_baujahr_2']?.setValue(null, {onlySelf: true});
      }
    }

    // fields could have been changed,
    this.fieldChange.emit();
  }

  /**
   * In this function all dynamic changes of the form is done. Based on selection options or value other fields are shown/hidden, options changed and validators adapted.
   *
   * @inheritDoc
   * @param values
   * @protected
   */
  protected onSetData(values: {[key: string]: any}): void {
    this.updateFields(values);
  }

  /**
   * @inheritDoc
   * @protected
   */
  protected onChange() {
    // check if the form has some fields which value changes other fields.
    if(this.fieldsForFormChanges.find(field => this.form.get(field)) != undefined) {
      this.updateFields(this.getData());
    }
  }

}
